import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

const ROUTES = {
  home: "/",
  services: "/services",
  about: "/about",
  "track-record": "/track-record",
  network: "/network",
  "why-us": "/why-us",
  insights: "/insights",
  contact: "/contact",
};

const PRIMARY = ["home", "services", "about", "network", "contact"];
const MORE = ["track-record", "why-us", "insights"];

export default function Navbar({ brand, nav }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobOpen, setMobOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);

  const location = useLocation();
  const moreRef = useRef(null);

  // Scroll background effect
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobOpen(false);
    document.body.style.overflow = "";
  }, [location.pathname]);

  // Lock scroll when mobile menu open
  useEffect(() => {
    document.body.style.overflow = mobOpen ? "hidden" : "";
  }, [mobOpen]);

  // Close "More" dropdown when clicking outside
  useEffect(() => {
    const handleClick = (e) => {
      if (moreRef.current && !moreRef.current.contains(e.target)) {
        setMoreOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const primaryNav = nav?.filter(n => PRIMARY.includes(n.page)) || [];
  const moreNav = nav?.filter(n => MORE.includes(n.page)) || [];
  const isMoreActive = moreNav.some(
    n => location.pathname === ROUTES[n.page]
  );

  return (
    <>
      <nav className={`nav${scrolled ? " s" : ""}`}>
        
        {/* LOGO */}
        <Link to="/" className="nav-logo">
          {brand?.logoImage ? (
            <img
              src={brand.logoImage}
              alt={brand.name}
              className="nav-logo-img"
            />
          ) : (
            brand?.logoText || "PR Elite Estate"
          )}
        </Link>

        {/* DESKTOP LINKS */}
        <ul className="nav-links">
          {primaryNav.map(item => (
            <li key={item.page}>
              <Link
                to={ROUTES[item.page] || "/"}
                className={
                  location.pathname === (ROUTES[item.page] || "/")
                    ? "act"
                    : ""
                }
              >
                {item.label}
              </Link>
            </li>
          ))}

          {/* MORE DROPDOWN */}
          {moreNav.length > 0 && (
            <li className="nav-more-wrap" ref={moreRef}>
              <button
                className={`nav-more-btn${
                  isMoreActive ? " act" : ""
                }`}
                onClick={() => setMoreOpen(v => !v)}
              >
                More
                <span
                  className={`nav-more-arrow${
                    moreOpen ? " up" : ""
                  }`}
                >
                  ▾
                </span>
              </button>

              {moreOpen && (
                <div className="nav-dropdown">
                  {moreNav.map(item => (
                    <Link
                      key={item.page}
                      to={ROUTES[item.page] || "/"}
                      className="nav-drop-item"
                      onClick={() => setMoreOpen(false)}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              )}
            </li>
          )}
        </ul>

        {/* DESKTOP CTA */}
        <Link to="/contact" className="nav-enq btn btn-o">
          Enquire Now
        </Link>

        {/* BURGER */}
        <button
          className={`burger${mobOpen ? " o" : ""}`}
          onClick={() => setMobOpen(v => !v)}
          aria-label="Menu"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {/* MOBILE FULLSCREEN MENU */}
      <div className={`mob${mobOpen ? " o" : ""}`}>
        <button
          className="mob-x"
          onClick={() => setMobOpen(false)}
        >
          ✕
        </button>

        {nav?.map(item => (
          <Link
            key={item.page}
            to={ROUTES[item.page] || "/"}
            className={
              location.pathname === (ROUTES[item.page] || "/")
                ? "act"
                : ""
            }
          >
            {item.label}
          </Link>
        ))}

        <Link
          to="/contact"
          className="btn btn-r mob-cta"
        >
          Enquire Now
        </Link>
      </div>
    </>
  );
}